import React, { Component } from 'react';
import './cssgrid.scss';

class CategGridProductList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            quantities: {},
        };
    }

    handleImageLoaded() {
        document.getElementsByClassName("page-loader")[0].style.display = "none";
    }

    stopLoading() {
        document.getElementsByClassName("page-loader")[0].style.display = "none";
    }

    getQty = (product) => {
        return this.state.quantities[product.id] || 1;
    }

    minusQty = (product) => {
        const current = this.getQty(product);
        if (current > 1) {
            this.setState((prev) => ({
                quantities: { ...prev.quantities, [product.id]: current - 1 },
            }));
        }
    }

    plusQty = (product) => {
        const current = this.getQty(product);
        if (typeof product.stock === 'number' && current >= product.stock) return;
        this.setState((prev) => ({
            quantities: { ...prev.quantities, [product.id]: current + 1 },
        }));
    }

    changeQty = (product, e) => {
        const value = parseInt(e.target.value, 10);
        if (!isNaN(value) && value > 0) {
            this.setState((prev) => ({
                quantities: { ...prev.quantities, [product.id]: value },
            }));
        }
    }

    getProductImage = (product) => {
        // Definir el orden de prioridad de las imágenes
        const images = ['url','image_4', 'image_1', 'image_2', 'image_3', 'logo'];
    
        // Buscar la primera imagen disponible (que no sea NULL ni undefined)
        for (let image of images) {
            if (product[image] && product[image] !== null && product[image] !== undefined) {
                return product[image]; // Retorna la imagen que esté disponible
            }
        }
    
        // Si ninguna imagen está disponible, retorna una imagen por defecto
        return null;
    };
    
    

    render() {
        const { products, categoria, handlerAddCart, symbol } = this.props;  
        const colorBoton = categoria.color;
        const textColor = categoria.text_color || '#161616';
        const url_image = `${process.env.REACT_APP_URL_FILES}images/products/`;

        // Dividir los productos en grupos de dos
        const groupedProducts = [];
        for (let i = 0; i < products.length; i += 2) {
            groupedProducts.push(products.slice(i, i + 2)); // Toma de a 2 productos
        }

        return (
            <div className="container">
                {/* Agrupar productos en contenedores */}
                <div className="products-grid">
                    {/* Iterar sobre los grupos de productos */}
                    {groupedProducts.map((group, groupIndex) => (
                        <div key={groupIndex} className="product-group">
                            {/* Iterar sobre cada producto dentro del grupo */}
                            {group.map((product, index) => {
                                const quantity = this.getQty(product);
                                return (
                                <div
                                    key={index}
                                    className="product-item"
                                    style={{
                                        border: `2px solid ${colorBoton}`,
                                        borderRadius: '10px',
                                    }}
                                >
                                    {product && (this.getProductImage(product)) ? (
                                        <div
                                            className="img-container"
                                            style={{
                                                width: '100px',
                                                height: '100px',
                                                overflow: 'hidden',
                                                borderRadius: '8px',
                                                marginTop: '4px',
                                            }}
                                        >
                                            <img
                                                src={url_image + this.getProductImage(product)}
                                                alt={product.name}
                                                className="img-fluid"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    objectPosition: 'center',
                                                }}
                                                onLoad={this.handleImageLoaded}
                                                onError={this.handleImageLoaded}
                                            />
                                        </div>
                                    ) : (
                                        this.stopLoading() // Manejo de carga si no hay imagen disponible
                                    )}

                                    <h5 className="mt-3" style={{ color: textColor, textAlign: 'center' }}>{product.name}</h5>
                                    
                                    <div className="detail-total">
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            {product.old_price && product.old_price > 0 && (
                                            <label style={{ marginLeft: '10px', textDecoration: 'line-through', display: 'flex', alignItems: 'center' }}>
                                                <img
                                                src={`${process.env.PUBLIC_URL}/assets/images/icon/credit.png`}
                                                alt=""
                                                className="img-fluid"
                                                style={{ marginRight: '5px' }}
                                                />
                                                {(parseFloat(product.old_price * quantity)).toFixed(0)}
                                            </label>
                                            )}

                                            <label style={{ display: 'flex', marginLeft: '10px', alignItems: 'center' }}>
                                            <img
                                                src={`${process.env.PUBLIC_URL}/assets/images/icon/credit.png`}
                                                alt=""
                                                className="img-fluid"
                                                style={{ marginRight: '5px' }}
                                            />
                                            {parseFloat(product.price * quantity).toFixed(0)}
                                            </label>


                                        </div>
                                    </div>

                                    <div className="qty-box quanty-categ-prod" style={{ margin: '4px 0 8px' }}>
                                        <div className="input-group" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                                            <span className="input-group-prepend">
                                                <button
                                                    type="button"
                                                    className="btn quantity-left-minus"
                                                    style={{ minWidth: 40, minHeight: 40, padding: '4px 12px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'transparent', border: `1px solid ${colorBoton}`, color: textColor }}
                                                    onClick={() => this.minusQty(product)}
                                                    data-type="minus"
                                                    data-field=""
                                                >
                                                    <i className="fa fa-minus"></i>
                                                </button>
                                            </span>
                                            <input
                                                type="text"
                                                name="quantity"
                                                value={quantity}
                                                onChange={(e) => this.changeQty(product, e)}
                                                className="form-control input-number"
                                            />
                                            <span className="input-group-prepend">
                                                <button
                                                    type="button"
                                                    className="btn quantity-right-plus"
                                                    style={{ minWidth: 40, minHeight: 40, padding: '4px 12px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'transparent', border: `1px solid ${colorBoton}`, color: textColor }}
                                                    onClick={() => this.plusQty(product)}
                                                    data-type="plus"
                                                    data-field=""
                                                >
                                                    <i className="fa fa-plus"></i>
                                                </button>
                                            </span>
                                        </div>
                                    </div>

                                    <button
                                        className="btn btn-primary mt-2"
                                        style={{
                                            backgroundColor: colorBoton,
                                            border: `2px solid ${colorBoton}`,
                                            color: textColor,
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => handlerAddCart(product, quantity, null)}
                                    >
                                        AGREGAR
                                    </button>
                                </div>
                                );
                            })}
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default CategGridProductList;
